import { render } from "./FilterCredit.vue?vue&type=template&id=87b52be6"
import script from "./FilterCredit.vue?vue&type=script&lang=js"
export * from "./FilterCredit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__